var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c("update-eta-dialog", {
        attrs: { "load-id": _vm.loadId, type: _vm.etaUpdateToType },
        on: {
          refresh: function($event) {
            return _vm.refreshCurrentLoad()
          }
        },
        model: {
          value: _vm.showUpdateETADialog,
          callback: function($$v) {
            _vm.showUpdateETADialog = $$v
          },
          expression: "showUpdateETADialog"
        }
      }),
      _vm._v(" "),
      _c("pickup-load-dialog", {
        attrs: { "load-id": _vm._.get(_vm.currentLoad, "humanId", null) },
        on: {
          refresh: function($event) {
            return _vm.refreshCurrentLoad()
          }
        },
        model: {
          value: _vm.showPickupDialog,
          callback: function($$v) {
            _vm.showPickupDialog = $$v
          },
          expression: "showPickupDialog"
        }
      }),
      _vm._v(" "),
      _c("deliver-load-dialog", {
        attrs: { company: _vm.company, load: _vm.currentLoad },
        on: {
          refresh: function($event) {
            return _vm.refreshCurrentLoad()
          }
        },
        model: {
          value: _vm.showDeliverDialog,
          callback: function($$v) {
            _vm.showDeliverDialog = $$v
          },
          expression: "showDeliverDialog"
        }
      }),
      _vm._v(" "),
      _c("upload-bill-of-lading-dialog", {
        attrs: { "load-id": _vm._.get(_vm.currentLoad, "humanId", null) },
        on: { refresh: _vm.refreshCurrentLoad },
        model: {
          value: _vm.showAttachBillOfLadingDialog,
          callback: function($$v) {
            _vm.showAttachBillOfLadingDialog = $$v
          },
          expression: "showAttachBillOfLadingDialog"
        }
      }),
      _vm._v(" "),
      _c("cancel-load-dialog", {
        attrs: {
          "listing-human-id": _vm.loadGroupId,
          "booked-load-id": _vm._.get(_vm.currentLoad, "id", null),
          "load-id": _vm._.get(_vm.currentLoad, "humanId", null)
        },
        on: { refresh: _vm.removeLoad },
        model: {
          value: _vm.cancelModal,
          callback: function($$v) {
            _vm.cancelModal = $$v
          },
          expression: "cancelModal"
        }
      }),
      _vm._v(" "),
      _vm.currentLoad
        ? _c("v-repeat-load-group-dialog", {
            attrs: {
              loadGroupId: _vm.loadGroupId,
              sponsor: _vm.listingSponsorName,
              origin: _vm._f("originName")(_vm.listing),
              destination: _vm._f("destinationName")(_vm.listing),
              count: _vm.listing.loadCount || 1,
              isMobile: _vm.isMobile,
              loading: _vm.loadingBtn,
              company: _vm.company,
              "load-group": _vm.listing
            },
            on: {
              cancel: _vm.closeCopyLoadDialog,
              newLoad: function($event) {
                return _vm.closeCopyLoadDialog(true)
              }
            },
            model: {
              value: _vm.showCopyLoadDialog,
              callback: function($$v) {
                _vm.showCopyLoadDialog = $$v
              },
              expression: "showCopyLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.showAttachPhotoDialog,
            callback: function($$v) {
              _vm.showAttachPhotoDialog = $$v
            },
            expression: "showAttachPhotoDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "title" },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c(
                        "v-toolbar-side-icon",
                        [
                          _c("v-icon", { attrs: { color: "primary" } }, [
                            _vm._v("add_a_photo")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-toolbar-title", [_vm._v("Attach Photo")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "px-3", attrs: { column: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { column: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Caption or Name",
                          required: "",
                          rules: [
                            function() {
                              return (
                                _vm.attachedPhotoName.length > 0 ||
                                "Required field"
                              )
                            }
                          ]
                        },
                        model: {
                          value: _vm.attachedPhotoName,
                          callback: function($$v) {
                            _vm.attachedPhotoName = $$v
                          },
                          expression: "attachedPhotoName"
                        }
                      }),
                      _vm._v(" "),
                      _vm.uploadProgressPercentage !== null
                        ? _c("v-progress-linear", {
                            staticClass: "mt-0 pt-0",
                            model: {
                              value: _vm.uploadProgressPercentage,
                              callback: function($$v) {
                                _vm.uploadProgressPercentage = $$v
                              },
                              expression: "uploadProgressPercentage"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "photoAttachment",
                    attrs: { type: "file", hidden: "" },
                    on: {
                      change: function($event) {
                        return _vm.processPhotoAttachment($event)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary",
                      attrs: { disabled: _vm._.isEmpty(_vm.attachedPhotoName) },
                      on: { click: _vm.openPhotoAttachmentSelector }
                    },
                    [_vm._v("\n            Select Photo\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "accent" },
                      on: {
                        click: function($event) {
                          _vm.showAttachPhotoDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600" },
          model: {
            value: _vm.openPhotoHelpDialog,
            callback: function($$v) {
              _vm.openPhotoHelpDialog = $$v
            },
            expression: "openPhotoHelpDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "headline lighten-2 py-0 justify-end pr-0",
                  attrs: { "primary-title": "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", color: "primary", small: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.openPhotoHelpDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _c("p", { staticClass: "mb-1" }, [
                  _vm._v(
                    "\n            Upload a picture of anything which might make communication faster and easier. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n            Consider things that the customer, the stockyard, or the carrier might want to know:\n          "
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [_vm._v("Auction load card")]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Sick/injured animals")]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Your flat tire")]),
                  _vm._v(" "),
                  _c("li", [_vm._v("The gate attendant")]),
                  _vm._v(" "),
                  _c("li", [_vm._v("Traffic jam")]),
                  _vm._v(" "),
                  _c("li", [_vm._v("A nearby building (if you're lost)")])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            lazy: "",
            "max-width": _vm.$vuetify.breakpoint.smAndDown ? "90%" : "600px"
          },
          model: {
            value: _vm.showTimelineDialog,
            callback: function($$v) {
              _vm.showTimelineDialog = $$v
            },
            expression: "showTimelineDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "title" }, [
                _vm.timelineDialogBid
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("load-detail.", {
                              bidHumanId: _vm.timelineDialogBid.humanId
                            })
                          ) +
                          " "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.timelineDialogSettlement
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.timelineDialogSettlement.description) +
                          "\n        payable to " +
                          _vm._s(_vm.timelineDialogSettlement.paidToCompanyName)
                      )
                    ])
                  : _vm._e(),
                _vm._v("\n          Settlement timeline "),
                _vm.loadingData
                  ? _c("span", [_vm._v(" [ ... loading ]")])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.timelineDialogSettlement
                ? _c(
                    "v-layout",
                    { staticClass: "px-4 py-2", attrs: { row: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { column: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn-toggle",
                                {
                                  staticClass: "mb-2",
                                  attrs: { mandatory: "" },
                                  model: {
                                    value: _vm.viewToggle,
                                    callback: function($$v) {
                                      _vm.viewToggle = $$v
                                    },
                                    expression: "viewToggle"
                                  }
                                },
                                [
                                  _c(
                                    "v-btn",
                                    { attrs: { flat: "", value: "text" } },
                                    [
                                      _c("span", [_vm._v("Text Message")]),
                                      _vm._v(" "),
                                      _c("v-icon", [_vm._v("textsms")])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    { attrs: { flat: "", value: "file" } },
                                    [
                                      _c("span", [_vm._v("Upload File")]),
                                      _vm._v(" "),
                                      _c("v-icon", [_vm._v("attach_file")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-card", [
                            _c(
                              "div",
                              { staticClass: "pa-3" },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "" } },
                                  [
                                    _vm.viewToggle === "text"
                                      ? [
                                          _c(
                                            "v-flex",
                                            { attrs: { sm10: "", xs8: "" } },
                                            [
                                              _c("v-textarea", {
                                                attrs: {
                                                  block: "",
                                                  rows: 2,
                                                  label: "Type something..."
                                                },
                                                model: {
                                                  value: _vm.settlementText,
                                                  callback: function($$v) {
                                                    _vm.settlementText = $$v
                                                  },
                                                  expression: "settlementText"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-spacer"),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { sm2: "", xs4: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mr-0 px-0",
                                                  attrs: {
                                                    block: "",
                                                    loading: _vm.loadingBtn,
                                                    disabled: _vm.loadingBtn
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.sendSettlementMessage(
                                                        _vm
                                                          .timelineDialogSettlement
                                                          .id
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Send\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      : [
                                          _c(
                                            "v-flex",
                                            { attrs: { sm9: "", xs8: "" } },
                                            [
                                              _c("v-textarea", {
                                                attrs: {
                                                  block: "",
                                                  rows: 2,
                                                  label: "Type something..."
                                                },
                                                model: {
                                                  value: _vm.settlementText,
                                                  callback: function($$v) {
                                                    _vm.settlementText = $$v
                                                  },
                                                  expression: "settlementText"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("input", {
                                                ref: "settlementAttachment",
                                                attrs: {
                                                  type: "file",
                                                  hidden: ""
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.processSettlementAttachment(
                                                      $event,
                                                      _vm
                                                        .timelineDialogSettlement
                                                        .id
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { sm3: "", xs4: "" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "primary ml-0",
                                                  attrs: {
                                                    disabled: _vm._.isEmpty(
                                                      _vm.settlementText
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openFileSelector(
                                                        "settlementAttachment"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        Select File\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-layout", { staticClass: "px-3", attrs: { column: "" } }, [
                _c(
                  "div",
                  {
                    staticClass: "timeline-section",
                    class: {
                      "text-md-center text-lg-center text-sm-center pt-4":
                        _vm.loadingData
                    }
                  },
                  [
                    _vm.dialogTimeline && !_vm.loadingData
                      ? _c("timeline", {
                          attrs: {
                            "show-time": "",
                            "timeline-object": _vm.dialogTimeline
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loadingData
                      ? _c("v-progress-circular", {
                          attrs: { indeterminate: "", color: "primary" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "accent" },
                      on: { click: _vm.closeTimelineDialog }
                    },
                    [_vm._v("\n            Close\n          ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { staticClass: "pb-2", attrs: { wrap: "" } },
        [
          !_vm.embedded
            ? _c(
                "v-layout",
                { attrs: { "align-center": "", "justify-start": "" } },
                [
                  _c(
                    "v-chip",
                    {
                      attrs: {
                        label: "",
                        color: _vm.progressIcon.color,
                        "text-color": "white"
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v(_vm._s(_vm.progressIcon.icon))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.embedded
            ? _c(
                "v-toolbar",
                {
                  attrs: {
                    extended: _vm.isMobile,
                    dense: !_vm.isMobile,
                    flat: "",
                    height: "56"
                  }
                },
                [
                  _vm.isProducerWithPermissions
                    ? _c(
                        "v-toolbar-side-icon",
                        { on: { click: _vm.openCopyLoadDialog } },
                        [
                          _c("v-icon", { attrs: { color: "accent" } }, [
                            _vm._v("redo")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c(
                        "template",
                        { slot: "extension" },
                        [
                          _vm._.get(_vm.currentLoad, "billOfLading.link", false)
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { flat: "" },
                                  on: { click: _vm.openBillOfLading }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("attachment")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "ml-1 primary--text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("terms.bill-of-lading")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentLoad
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    href: _vm.gMapsLink,
                                    target: "_blank",
                                    flat: ""
                                  }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("map")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "ml-1 primary--text" },
                                        [_vm._v("View on Google Map")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                flat: "",
                                loading: _vm.loadingBtn,
                                disabled: _vm.loadingBtn
                              },
                              on: { click: _vm.checkIn }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "primary" } },
                                    [_vm._v("pin_drop")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "ml-1 primary--text" },
                                    [_vm._v("Checkin")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-toolbar-title",
                        { staticClass: "font-weight-bold" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.currentLoad.humanId) +
                              "\n        "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      !_vm.isMobile
                        ? [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  flat: "",
                                  loading: _vm.loadingBtn,
                                  color: "primary"
                                },
                                on: { click: _vm.refreshCurrentLoad }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { column: "" } },
                                  [
                                    _c("v-icon", [_vm._v("refresh")]),
                                    _vm._v(
                                      "\n                Reload\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._.get(
                              _vm.currentLoad,
                              "billOfLading.link",
                              false
                            )
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { flat: "" },
                                    on: { click: _vm.openBillOfLading }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [_vm._v("attachment")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ml-1 primary--text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("terms.bill-of-lading")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentLoad
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      href: _vm.gMapsLink,
                                      target: "_blank",
                                      flat: ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [_vm._v("map")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "ml-1 primary--text" },
                                          [_vm._v("Google Maps")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  flat: "",
                                  loading: _vm.loadingBtn,
                                  disabled: _vm.loadingBtn
                                },
                                on: { click: _vm.checkIn }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { column: "" } },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "primary" } },
                                      [_vm._v("pin_drop")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "ml-1 primary--text" },
                                      [_vm._v("Checkin")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  small: "",
                                  flat: "",
                                  loading: _vm.loadingBtn,
                                  color: "primary"
                                },
                                on: { click: _vm.refreshCurrentLoad }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { column: "" } },
                                  [
                                    _c("v-icon", [_vm._v("refresh")]),
                                    _vm._v(
                                      "\n                Reload\n              "
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                      _vm._v(" "),
                      _vm.isNonceUser
                        ? [
                            !_vm.isDelivered && _vm.canUpdateLoadProgress
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "accent",
                                      dark: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openDeliverDialog()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c("v-icon", [_vm._v("play_for_work")]),
                                        _vm._v(
                                          "\n                Complete\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm.isDelivered && _vm.canUpdateLoadProgress
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "accent",
                                      dark: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showAttachBillOfLadingDialog = true
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "primary" } },
                                          [
                                            _vm._v(
                                              "\n                  attachment\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                Upload " +
                                            _vm._s(
                                              _vm.$t("terms.bill-of-lading")
                                            ) +
                                            "\n              "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm.canCancel ||
                          ((_vm.isScheduled ||
                            _vm.isInTransit ||
                            _vm.isDelivered) &&
                            _vm.canUpdateLoadProgress)
                        ? _c(
                            "v-menu",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    flat: "",
                                    color: "accent",
                                    dark: ""
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c("v-icon", [_vm._v("more_horiz")]),
                                      _vm._v(
                                        "\n                Update\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list",
                                [
                                  _vm.isScheduled && _vm.canUpdateLoadProgress
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showPickupDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                    arrow_upward\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                  Pick Up\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isInTransit && _vm.canUpdateLoadProgress
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openDeliverDialog()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                    play_for_work\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                  Deliver\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isScheduled && _vm.canUpdateLoadProgress
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openUpdateETADialog(
                                                "pickup"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("drive_eta")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                  Update Pick up ETA\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isInTransit && _vm.canUpdateLoadProgress
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.openUpdateETADialog(
                                                "delivery"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("drive_eta")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                  Update Delivery ETA\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canCancel
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.displayCancelModal()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "accent" } },
                                                [_vm._v("cancel")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                  Cancel Truck\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDelivered && _vm.canUpdateLoadProgress
                                    ? _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.showAttachBillOfLadingDialog = true
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [
                                                  _vm._v(
                                                    "\n                    attachment\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                  Upload " +
                                                _vm._s(
                                                  _vm.$t("terms.bill-of-lading")
                                                ) +
                                                "\n                "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: { "scroll-section": !_vm.isMobile } },
        [
          _vm.currentLoad
            ? _c(
                "v-layout",
                { staticClass: "mt-2", attrs: { wrap: "" } },
                [
                  _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                    _c("span", { staticClass: "title font-weight-bold" }, [
                      _vm._v(
                        "Pickup: " + _vm._s(_vm.notificationPickupTime.value)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "body-2 font-italic" }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.notificationPickupTime.providedBy) +
                          ")"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "title font-weight-bold",
                      attrs: { xs12: "", md6: "" }
                    },
                    [
                      _c("span", { staticClass: "title font-weight-bold" }, [
                        _vm._v(
                          "Delivery: " +
                            _vm._s(_vm.notificationDeliveryTime.value)
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "body-2 font-italic" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.notificationDeliveryTime.providedBy) +
                            ")"
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentLoad
            ? _c("progress-arrows", {
                staticClass: "hidden-xs-only",
                attrs: {
                  status: _vm.currentLoadStatus,
                  "show-paid": !_vm.isTruckingDriverViewing
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { "align-center": "", "justify-center": "", row: "" } },
            [
              _c(
                "v-flex",
                {
                  class: { "mr-4": !_vm.isMobile },
                  attrs: { md6: "", xs12: "" }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-list",
                        {
                          staticClass: "py-0",
                          class: { "desktop-list": !_vm.isMobile }
                        },
                        [
                          _vm.loadModel.customerName(_vm.currentLoad)
                            ? _c(
                                "v-list-tile",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.followCustomerCompanyLink
                                        ? _vm.$router.push({
                                            name: "company.settings",
                                            params: {
                                              id: _vm.loadModel.customerCompany(
                                                _vm.currentLoad
                                              ).id
                                            }
                                          })
                                        : null
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [_vm._v("Customer")])
                                      ]),
                                      _vm._v(" "),
                                      _vm.hasCustomerCompanyProfile
                                        ? _c(
                                            "v-list-tile-sub-title",
                                            [
                                              _c("v-icon", [
                                                _vm._v("business")
                                              ]),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.loadModel.customerName(
                                                      _vm.currentLoad
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        : _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.loadModel.customerName(
                                                    _vm.currentLoad
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-group",
                            {
                              model: {
                                value: _vm.reqListGroup,
                                callback: function($$v) {
                                  _vm.reqListGroup = $$v
                                },
                                expression: "reqListGroup"
                              }
                            },
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [_vm._v("Requirements")])
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.requireWashout
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-color": "#352208",
                                                "icon-name": "hose"
                                              }
                                            },
                                            [_c("icon-hose")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v("Washout")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.requireWoodChips
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-color": "#352208",
                                                viewBox: "0 0 5 5",
                                                "icon-name": "wood"
                                              }
                                            },
                                            [_c("icon-wood")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v("Wood Chips")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.requireWeatherboards
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [
                                          _c(
                                            "icon-base",
                                            {
                                              attrs: {
                                                width: "35",
                                                height: "35",
                                                "icon-name": "cold",
                                                "icon-color": "#352208"
                                              }
                                            },
                                            [_c("icon-cold")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v("Weatherboards")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                      See instructions in load history\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-group",
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm.isDispatched
                                          ? _c("b", [_vm._v("Dispatcher")])
                                          : _c("b", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "components.load-details.self-contracted"
                                                  )
                                                )
                                              )
                                            ])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(_vm.listingCompany.name) +
                                            "\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isListingCompanyAdminViewing
                                ? _c(
                                    "v-flex",
                                    { staticStyle: { "padding-left": "10px" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                path:
                                                  "/companies/" +
                                                  _vm.listingCompany.id +
                                                  "/profile"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("business")]
                                          ),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.listingCompany.name) +
                                              " Profile\n                  "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.listingCompanyProfile && _vm.currentLoad
                                ? _c("company-profile-card", {
                                    attrs: {
                                      "company-profile":
                                        _vm.listingCompanyProfile,
                                      load: _vm.currentLoad,
                                      role: _vm.LoadCompanyRole.Producer
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.truckingCompany && _vm.truckingCompany.id
                            ? _c(
                                "v-list-group",
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _c("b", [_vm._v("Carrier")])
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.truckingCompany.name
                                                ) +
                                                "\n                    "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.isTruckingAdminViewing
                                    ? _c(
                                        "v-flex",
                                        {
                                          staticStyle: {
                                            "padding-left": "10px"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.$router.push({
                                                    path:
                                                      "/companies/" +
                                                      _vm.truckingCompany.id +
                                                      "/profile"
                                                  })
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("business")]
                                              ),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.truckingCompany.name
                                                  ) +
                                                  " Profile\n                  "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.truckingCompanyProfile && _vm.currentLoad
                                    ? _c("company-profile-card", {
                                        attrs: {
                                          "company-profile":
                                            _vm.truckingCompanyProfile,
                                          load: _vm.currentLoad,
                                          role: _vm.LoadCompanyRole.Carrier
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [_vm._v("Carrier")])
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.haulingCompany.name) +
                                              "\n                    "
                                          ),
                                          _vm.assignedVendor
                                            ? _c("dispatcher-info", {
                                                attrs: {
                                                  company: _vm.company,
                                                  "vendor-dispatcher":
                                                    _vm.assignedVendor,
                                                  fab: ""
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "v-list-group",
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [_vm._v("Origin")])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("originName")(_vm.listing)
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isPickupAdminViewing
                                ? _c(
                                    "v-flex",
                                    { staticStyle: { "padding-left": "10px" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                path:
                                                  "/companies/" +
                                                  _vm.pickupCompany.id +
                                                  "/profile"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("business")]
                                          ),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.pickupCompany.name) +
                                              " Profile\n                  "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentLoad
                                ? _c("company-profile-card", {
                                    attrs: {
                                      load: _vm.currentLoad,
                                      role: _vm.LoadCompanyRole.OriginStockyard
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-group",
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [_vm._v("Destination")])
                                      ]),
                                      _vm._v(" "),
                                      _c("v-list-tile-sub-title", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm._f("destinationName")(
                                                _vm.listing
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isDropoffAdminViewing
                                ? _c(
                                    "v-flex",
                                    { staticStyle: { "padding-left": "10px" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.$router.push({
                                                path:
                                                  "/companies/" +
                                                  _vm.dropoffCompany.id +
                                                  "/profile"
                                              })
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("business")]
                                          ),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.dropoffCompany.name) +
                                              " Profile\n                  "
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentLoad
                                ? _c("company-profile-card", {
                                    attrs: {
                                      load: _vm.currentLoad,
                                      role:
                                        _vm.LoadCompanyRole.DestinationStockyard
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.driverSectionTitle
                            ? _c(
                                "v-list-group",
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(_vm.driverSectionTitle)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _vm.loadModel.assignedTruckingCompanyDriverName(
                                            _vm.currentLoad
                                          )
                                            ? _c(
                                                "v-list-tile-sub-title",
                                                [
                                                  _c("bqa-certificate-icon", {
                                                    attrs: {
                                                      small: "",
                                                      driver: _vm.driver
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.loadModel.assignedTruckingCompanyDriverName(
                                                          _vm.currentLoad
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.driver
                                    ? [
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [_vm._v("email")]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-content", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "mailto:" +
                                                      _vm.driver.contactEmail
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.driver.contactEmail
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "mr-2" },
                                                  [_vm._v("phone")]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-content", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "tel:" +
                                                      _vm.driver.contactPhone
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.driver.contactPhone
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile",
                                          [
                                            _c(
                                              "v-list-tile-avatar",
                                              { attrs: { size: 30 } },
                                              [
                                                _c("bqa-certificate-icon", {
                                                  attrs: {
                                                    responsive: "",
                                                    driver: _vm.driver
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._.get(
                                              _vm.driver,
                                              "bqaCertification.expires",
                                              false
                                            )
                                              ? _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c("v-list-tile-title", [
                                                      _vm._v(
                                                        "\n                        Expiration date\n                      "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list-tile-sub-title",
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDay"
                                                              )(
                                                                _vm.driver
                                                                  .bqaCertification
                                                                  .expires
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-list-tile-content",
                                                  [
                                                    _c("v-list-tile-title", [
                                                      _vm._v(
                                                        "\n                        Not Provided\n                      "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.canAssignDriver
                                    ? _c(
                                        "v-list-tile",
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("headset_mic")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-select-load-driver", {
                                            attrs: {
                                              load: _vm.currentLoad,
                                              company: _vm.company
                                            },
                                            on: {
                                              refresh: function($event) {
                                                return _vm.$emit(
                                                  "updateLoad",
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasBidHistory ||
                          _vm.customerSettlement ||
                          _vm.freightSettlement
                            ? _c(
                                "v-list-group",
                                [
                                  _c(
                                    "v-list-tile",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c("v-list-tile-title", [
                                            _c("b", [_vm._v("Settlement")])
                                          ]),
                                          _vm._v(" "),
                                          _vm._.get(
                                            _vm.customerSettlement,
                                            "billOfLadingNumber",
                                            false
                                          )
                                            ? _c("v-list-tile-sub-title", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "font-italic"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "terms.bill-of-lading"
                                                          )
                                                        ) +
                                                        ": " +
                                                        _vm._s(
                                                          _vm._.get(
                                                            _vm.customerSettlement,
                                                            "billOfLadingNumber"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._.get(
                                    _vm.customerSettlement,
                                    "billOfLadingNumber"
                                  ) &&
                                  !_vm._.get(
                                    _vm.currentLoad,
                                    "billOfLading.link",
                                    false
                                  )
                                    ? _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-list-tile",
                                            [
                                              _c(
                                                "v-list-tile-content",
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                        Retry Creating the " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "terms.bill-of-lading"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-list-tile-sub-title", [
                                                    _vm._v(
                                                      "\n                        Attempt to Create the " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "terms.bill-of-lading"
                                                          )
                                                        ) +
                                                        " with attached images again\n                      "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "pl-1 pr-1",
                                                      attrs: {
                                                        flat: "",
                                                        color: "accent"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.requestRedoBillOfLading(
                                                            _vm.customerSettlement
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        { staticClass: "pr-2" },
                                                        [_vm._v("refresh")]
                                                      ),
                                                      _vm._v(
                                                        "\n                        Redo BoL\n                      "
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    {
                                      staticClass: "pl-3 pr-3",
                                      attrs: { wrap: "", "justify-start": "" }
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          attrs: { "three-line": "", dense: "" }
                                        },
                                        [
                                          _vm.hasBidHistory
                                            ? [
                                                _c("v-subheader", [
                                                  _vm._v("Bid History")
                                                ]),
                                                _vm._v(" "),
                                                _vm.$vuetify.breakpoint
                                                  .smAndDown
                                                  ? _c(
                                                      "v-card",
                                                      [
                                                        _c("v-card-title", [
                                                          _c("div", [
                                                            _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Winning bid " +
                                                                    _vm._s(
                                                                      _vm._.get(
                                                                        _vm.currentLoad,
                                                                        "bid.humanId"
                                                                      )
                                                                    )
                                                                )
                                                              ])
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                "\n                              $" +
                                                                  _vm._s(
                                                                    _vm._.get(
                                                                      _vm.currentLoad,
                                                                      "bid.amount"
                                                                    )
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "font-italic"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "billed to " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .$t(
                                                                            "components.load-details.self-contracted"
                                                                          )
                                                                          .toLocaleLowerCase()
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ])
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-card-actions",
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "pa-2",
                                                                attrs: {
                                                                  color:
                                                                    "accent"
                                                                }
                                                              },
                                                              [_vm._v("gavel")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("v-spacer"),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "accent pr-2"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.openBidTimelineDialog(
                                                                      _vm
                                                                        .currentLoad
                                                                        .bid
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "chat"
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                            Review\n                          "
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-list-tile",
                                                      { attrs: { avatar: "" } },
                                                      [
                                                        _c(
                                                          "v-list-tile-content",
                                                          [
                                                            _c(
                                                              "v-list-tile-title",
                                                              [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    "Winning bid " +
                                                                      _vm._s(
                                                                        _vm._.get(
                                                                          _vm.currentLoad,
                                                                          "bid.humanId"
                                                                        )
                                                                      )
                                                                  )
                                                                ])
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "v-list-tile-sub-title",
                                                              [
                                                                _vm._v(
                                                                  "\n                            $" +
                                                                    _vm._s(
                                                                      _vm._.get(
                                                                        _vm.currentLoad,
                                                                        "bid.amount"
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "font-italic"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "billed to " +
                                                                        _vm._s(
                                                                          _vm
                                                                            .$t(
                                                                              "components.load-details.self-contracted"
                                                                            )
                                                                            .toLocaleLowerCase()
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-list-tile-action",
                                                          [
                                                            _c(
                                                              "v-list-tile-action-text",
                                                              [
                                                                _c(
                                                                  "v-layout",
                                                                  {
                                                                    attrs: {
                                                                      column: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "pa-2",
                                                                        attrs: {
                                                                          color:
                                                                            "accent"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "gavel"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "accent pr-2",
                                                                          small:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.openBidTimelineDialog(
                                                                              _vm
                                                                                .currentLoad
                                                                                .bid
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            staticClass:
                                                                              "pa-2"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "chat"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "\n                                Review\n                              "
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c("v-divider")
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.customerSettlement
                                            ? [
                                                _c("v-subheader", [
                                                  _vm._v("Billed to Customer")
                                                ]),
                                                _vm._v(" "),
                                                _c("settlement-card", {
                                                  attrs: {
                                                    "settlement-item":
                                                      _vm.customerSettlement,
                                                    "invoicing-company":
                                                      _vm.customerSettlementInvoicingCompany ||
                                                      {}
                                                  },
                                                  on: {
                                                    "open-timeline": function(
                                                      $event
                                                    ) {
                                                      return _vm.openTimelineDialog(
                                                        $event
                                                      )
                                                    },
                                                    refresh:
                                                      _vm.refreshCurrentLoad,
                                                    redoBoL: function($event) {
                                                      return _vm.openTimelineDialog(
                                                        $event
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("v-divider")
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.freightSettlement &&
                                          _vm.freightSettlement.length
                                            ? _c("v-subheader", [
                                                _vm._v(
                                                  "\n                      Freight\n                    "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm._l(
                                            _vm.freightSettlement,
                                            function(settlementItem, index) {
                                              return [
                                                _c("settlement-card", {
                                                  key: index + "_settlement",
                                                  attrs: {
                                                    "settlement-item": settlementItem,
                                                    "invoicing-company":
                                                      _vm.loadCompanies[
                                                        settlementItem
                                                          .paidToCompanyId
                                                      ] || {}
                                                  },
                                                  on: {
                                                    "open-timeline": function(
                                                      $event
                                                    ) {
                                                      return _vm.openTimelineDialog(
                                                        $event
                                                      )
                                                    },
                                                    refresh:
                                                      _vm.refreshCurrentLoad
                                                  }
                                                })
                                              ]
                                            }
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._.get(
                            _vm.currentLoad,
                            "delivery.billOfLadingNumber",
                            false
                          )
                            ? _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("terms.bill-of-lading")
                                            ) + " Number: "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "font-italic" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.currentLoad.delivery
                                                    .billOfLadingNumber
                                                ) +
                                                "\n                     "
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$vuetify.breakpoint.smAndDown
                        ? [
                            _c("load-map", {
                              staticClass: "py-2 px-3",
                              attrs: {
                                hideOnSmall: "",
                                load: _vm.currentLoad,
                                "position-markers": _vm.checkinEvents,
                                "origin-place-id": _vm.originPlaceId,
                                "destination-place-id": _vm.destinationPlaceId
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.$vuetify.breakpoint.smAndDown
                ? _c(
                    "v-flex",
                    { attrs: { md6: "" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("load-map", {
                            attrs: {
                              load: _vm.currentLoad,
                              "position-markers": _vm.checkinEvents,
                              "origin-place-id": _vm.originPlaceId,
                              "destination-place-id": _vm.destinationPlaceId
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "my-0 px-2 py-2 text-lg-center text-md-center"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.distanceLabel(
                                      _vm.loadModel.loadedMiles(_vm.currentLoad)
                                    )
                                  ) +
                                  ". Based on Google Maps\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c(
                "v-layout",
                { staticClass: "my-2" },
                [
                  _c(
                    "v-icon",
                    {
                      on: {
                        click: function($event) {
                          return _vm.getFulfillment()
                        }
                      }
                    },
                    [_vm._v("timeline")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "headline ml-2" }, [
                    _vm._v("Load History")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-layout",
                    {
                      staticClass: "px-4 py-2",
                      attrs: { wrap: "", "justify-space-between": "" }
                    },
                    [
                      _c("div", { staticClass: "subheading" }, [
                        _vm._v("Fulfillment Timeline")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "px-4 py-2",
                      attrs: { wrap: "", "flex-end": "" }
                    },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "mx-1" },
                        [
                          _c("input", {
                            ref: "inpsectionPapersAttachment",
                            attrs: { type: "file", multiple: "", hidden: "" },
                            on: {
                              change: function($event) {
                                return _vm.processInspectionPapers($event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "primary",
                              attrs: { block: "" },
                              on: { click: _vm.openInspectionPapersSelector }
                            },
                            [
                              _vm._v(
                                "\n                Upload Inspection Papers\n              "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "ml-1" },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs10: "", sm10: "", md10: "" } },
                                [
                                  _c(
                                    "v-badge",
                                    { attrs: { right: "", color: "accent" } },
                                    [
                                      _c(
                                        "template",
                                        { slot: "badge" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: { dark: "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.openPhotoHelpDialog = true
                                                }
                                              }
                                            },
                                            [_vm._v("help")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "primary",
                                          attrs: { block: "" },
                                          on: {
                                            click: function($event) {
                                              return _vm.openPhotoUploadModal(
                                                "fulfillment"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Upload Photo\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { staticClass: "px-4 py-2", attrs: { row: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { "justify-start": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm10: "", xs8: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  block: "",
                                  rows: 2,
                                  label: "Type something..."
                                },
                                model: {
                                  value: _vm.fulfillmentText,
                                  callback: function($$v) {
                                    _vm.fulfillmentText = $$v
                                  },
                                  expression: "fulfillmentText"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { sm2: "", xs4: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-0 px-0",
                                  attrs: {
                                    block: "",
                                    loading: _vm.loadingBtn,
                                    disabled: _vm.loadingBtn
                                  },
                                  on: { click: _vm.sendFulfillmentMessage }
                                },
                                [_vm._v("Send")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "px-4 py-2",
                      attrs: { column: "", wrap: "" }
                    },
                    [
                      _vm.fulfillmentTimeline && _vm.currentLoad
                        ? _c("timeline", {
                            attrs: {
                              load: _vm.currentLoad,
                              "timeline-object": _vm.fulfillmentTimeline
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    {
                      staticClass: "px-4 py-2",
                      attrs: { column: "", wrap: "", "align-end": "" }
                    },
                    [
                      _vm._.get(
                        _vm.currentLoad,
                        "inspectionPapers.link",
                        false
                      ) ||
                      _vm._.get(_vm.currentLoad, "billOfLading.link", false) ||
                      _vm.fulfillmentAttachmentEvents.length
                        ? _c("v-flex", [_c("b", [_vm._v("Attachments")])])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._.get(_vm.currentLoad, "inspectionPapers.link", false)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "primary--text mx-0 px-0",
                              attrs: { flat: "" },
                              on: { click: _vm.openInspectionPapers }
                            },
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("attachment")
                              ]),
                              _vm._v(
                                "\n              View Inspection Papers\n            "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._.get(_vm.currentLoad, "billOfLading.link", false)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "primary--text mx-0 px-0",
                              attrs: { flat: "" },
                              on: { click: _vm.openBillOfLading }
                            },
                            [
                              _c("v-icon", { attrs: { color: "primary" } }, [
                                _vm._v("attachment")
                              ]),
                              _vm._v(
                                "\n              View " +
                                  _vm._s(_vm.$t("terms.bill-of-lading")) +
                                  "\n            "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.fulfillmentAttachmentEvents, function(
                        attachmentEvent,
                        idx
                      ) {
                        return _c(
                          "v-layout",
                          { key: "fulfil-event-" + idx },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "primary--text mx-0 px-0",
                                attrs: { flat: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.openAttachment(attachmentEvent)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { color: "primary" } }, [
                                  _vm._v("attachment")
                                ]),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(attachmentEvent.message) +
                                    " (" +
                                    _vm._s(
                                      _vm._f("formatDate")(
                                        attachmentEvent.timestamp
                                      )
                                    ) +
                                    ")\n              "
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-018cc059", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018cc059","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/simple/LoadDetail.vue
// module id = null
// module chunks = 